module.exports = __webpack_public_path__ + "static/media/login_bg_max.ede0a4d9.png";